import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import TableItemsNotifications from "./TableItemsNotifications";
import Pagination from "../Pagination/Pagination";
import NotificationModal from "./NotificationModal";
import TableItemsNotificationsResponsive from "./TableItemsNotificationsResponsive";
import { getAllNotifications, setPage } from "../../store/slices/apiNotificationsSlice";


const TableNotifications = () => {
  const dispatch = useDispatch();
  const notificationsData = useSelector((state) => state.apiNotifications?.data || {});
  const dataNotifications = notificationsData.data || [];
  const totalCount = notificationsData.totalCount || 0;
  const currentPage = useSelector((state) => state.apiNotifications.currentPage || 1);

  useEffect(() => {
    dispatch(getAllNotifications({ page: currentPage }));
  }, [dispatch, currentPage]);

  const handlePageChange = (page) => {
    dispatch(setPage(page));
  };

  const notificationsToShow = dataNotifications;

  return (
    <div className="p-3">
      <div className="flex items-center justify-between pb-4 bg-white dark:bg-gray-900">
        <div></div>
        <div>
          <NotificationModal />
        </div>
      </div>
      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        <div className="hidden sm:block">
          <table className="w-full text-sm text-left text-gray-700 dark:text-gray-300">
            <thead className="text-xs uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr className="border-b hover:bg-gray-50">
                <th scope="col" className="px-6 py-3">Titulli</th>
                <th scope="col" className="px-6 py-3">Mesazhi</th>
                <th scope="col" className="px-6 py-3 w-26 text-center">Aksionet</th>
              </tr>
            </thead>
            <tbody>
              <TableItemsNotifications dataNotifications={notificationsToShow} />
            </tbody>
          </table>
        </div>
        <div className="block sm:hidden space-y-4">
          <TableItemsNotificationsResponsive dataNotifications={notificationsToShow} />
        </div>
        {/* Responsive version can be added if needed */}
        <Pagination
          currentPage={currentPage}
          totalCount={totalCount}
          onPageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default TableNotifications; 